import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Result from '../views/Result.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { 
      title: '龙蟠科技正品查询平台'  // 这里写页面标题
    }
  },
  {
    path: '/result',
    name: 'Result',
    component: Result,
    meta: { 
      title: 'lopal anti-counterfeiting'  // 这里写页面标题
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 添加路由守卫，验证登录状态
router.beforeEach((to, from, next) => {
   if (to.meta.title) {
    document.title = to.meta.title  // 核心代码
  }
  next()
})

export default router
